export const IF_FUNCTION_TYPE = {
  UNKNOWN: 'unknown',
  DEVICE_MOBILE: 'device=mobile',
  AUDIENCE_IN: 'audience IN',
};
